// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prof-education-modal__content-wrapper[data-v-1cfdaa32] {\n  display: block;\n  width: 100%;\n}\n.prof-education-modal__add-school-btn[data-v-1cfdaa32] {\n  display: inline-block;\n  width: auto;\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
